import React, { useRef } from 'react'
import styled from 'styled-components'
import { useOnClickOutside } from '../../../hooks/useOnClickOutside'
import { ApplicationModal } from '../../../state/application/actions'
import { useModalOpen, useToggleModal } from '../../../state/application/hooks'
import { Menu } from 'react-feather'
import { match, NavLink } from 'react-router-dom'
import * as H from 'history'

const StyledMenuButton = styled.button`
  width: 50px;
  height: 45px;
  border: none;
  // border-radius: 25px;
  // border: solid 1px ${({ theme }) => theme.bg4};
  background-color: transparent;
  margin: 0;
  padding: 0;
  
  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg3};
    border-radius: 10px;
    box-shadow: ${({ theme }) => theme.shadow1};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`
const StyledMenu = styled.div`
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
`

const MenuFlyout = styled.span`
  min-width: 9rem;
  // background-color: ${({ theme }) => theme.bg1};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 12px;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 50px;
  right: 0rem;
  z-index: 100;

  background-image: linear-gradient(to bottom, #11314a, #0c2539);
  border: solid 1px #224765;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    top: 50px;
  `};
`

const activeClassName = 'ACTIVE'
const MenuItem = styled(NavLink).attrs({ activeClassName })`
  flex: 1;
  padding: 0.5rem 0.5rem;
  color: ${({ theme }) => theme.text1};
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.text1};
    cursor: pointer;
  }
  > svg {
    margin-right: 8px;
  }
`

type MainMenuProps = {
  navLinks: {
    id: string
    name: string
    href: string
    isActive?: (match: match | null, { pathname }: H.Location) => boolean
  }[]
}

export default function MainMenu({ navLinks }: MainMenuProps) {
  const node = useRef<HTMLDivElement>()
  const open = useModalOpen(ApplicationModal.MAIN_MENU)
  const toggle = useToggleModal(ApplicationModal.MAIN_MENU)
  useOnClickOutside(node, open ? toggle : undefined)

  return (
    <StyledMenu ref={node as any}>
      <StyledMenuButton onClick={toggle}>
        <Menu size={'24'} />
      </StyledMenuButton>

      {open && (
        <MenuFlyout>
          {navLinks.map(link => (
            <MenuItem key={link.id} to={link.href} onClick={toggle}>
              {link.name}
            </MenuItem>
          ))}
        </MenuFlyout>
      )}
    </StyledMenu>
  )
}
